import React from 'react'

const PersonPlusIcon = () => {
	return (
		<svg width={30} height={29} viewBox='0 0 30 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_1080_6037)' fill='currentColor'>
				<path d='M10.809 0a7.044 7.044 0 015.081 2.015 7.06 7.06 0 012.118 5.045 7.068 7.068 0 01-4.455 6.565 7.046 7.046 0 01-2.744.495h-.235a7.048 7.048 0 01-4.892-2.119 7.066 7.066 0 010-9.882A7.048 7.048 0 0110.574 0h.235zM0 27.086V25.61c0-6.597 3.552-10.074 10.138-10.074h.948c6.586 0 10.3 3.49 10.3 10.074v1.475C21.38 29.739 0 29.534 0 27.086zM30 12.071H19.319v3.249H30V12.07z' />
				<path d='M26.283 19.044V8.35H23.04v10.694h3.244z' />
			</g>
			<defs>
				<clipPath id='clip0_1080_6037'>
					<path fill='#fff' d='M0 0H30V29H0z' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default PersonPlusIcon
